









import Vue from 'vue';
import AppModule from '../../common/components/AppModule.vue';
import {AppModuleConfig, AppModuleNavItem} from '../../common/models/AppModuleConfig';
import appClient from '../../apis';
import ModuleUpgrade from '../../common/components/ModuleUpgrade.vue';

const moduleNavs: AppModuleNavItem[] = [
  { name: '规则配置', alias: 'settings' },
  { name: '数据总览', alias: 'overview' },
];

const module: AppModuleConfig = {
  module: 'rule',
  name: '自动化营销',
  navs: moduleNavs,
  description: '基于用户行为分析技术、个性化推送服务技术，帮助商家做精准的智能营销。',
};

export default Vue.extend({
  components: {
    AppModule,
    ModuleUpgrade,
  },
  data() {
    return {
      module,
      hasRights: true,
    };
  },
  methods: {
    getRights() {
      appClient.hasRights({module: 'rule'}).success((r) => {
        this.hasRights = r;
      });
    },
  },
  mounted() {
    this.getRights();
  },
});
